/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Targets from 'astro/config/url/targets';


let Config = {};


Config['targets'] = Targets;


export default Config;
